webpackJsonp([226185481098933],{

/***/ 62:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pageData = [{
	  order: 1,
	  title: "Flexibel",
	  heading: "Flexibel",
	  subheading: "Ordet flexibel användes i över 9000 annonser i Platsbanken (7 juni 2018).",
	  dl1: "Flexibel är ett otydligt begrepp för många som söker jobb.",
	  dl2: "Flexibel används ofta i annonser för både psykolog och svetsare. Men söker man verkligen samma kompetens?",
	  navTitle: "Ta reda på hur du kan finslipa dina uttryck!",
	  link: "/flexibel/"
	}, {
	  order: 2,
	  title: "Quiz",
	  heading: "Flexibel",
	  subheading: "På en arbetsmarknad som snabbt förändras är det eftertraktat att vara flexibel.",
	  link: "/flexibel/02/",
	  quizHeading: "Vad gör en flexibel kollega enligt dig?",
	  quizAnswer1: {
	    content: "Bemöter andra utifrån deras behov",
	    note: "Relationskompetens"
	  },
	  quizAnswer2: {
	    content: "Hanterar flera arbetsuppgifter eller information parallellt",
	    note: "Prioriteringskompetens"
	  },
	  quizAnswer3: {
	    content: "Ändrar arbetssätt och förhållningssätt när det krävs",
	    note: "Anpassningskompetens"
	  },
	  quizAnswer4: {
	    content: "Söker och vågar prova okonventionella perspektiv och idéer",
	    note: "Utvecklingskompetens"
	  },
	  modal: {
	    heading: "Flexibel",
	    subheading: "Grattis!",
	    body: "Nu kan du vara ännu tydligare med vad du efterfrågar. Gå vidare och ser hur du undviker fler floskler!",
	    buttonText: "Fortsätt jakten!"
	  }
	}];
	
	exports.default = pageData;
	module.exports = exports["default"];

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(105);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Main = __webpack_require__(115);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _ModalContext = __webpack_require__(42);
	
	var _Choices = __webpack_require__(87);
	
	var _Choices2 = _interopRequireDefault(_Choices);
	
	var _floskelFlexibel = __webpack_require__(204);
	
	var _floskelFlexibel2 = _interopRequireDefault(_floskelFlexibel);
	
	var _gemFlexibel = __webpack_require__(53);
	
	var _gemFlexibel2 = _interopRequireDefault(_gemFlexibel);
	
	var _flexibel = __webpack_require__(62);
	
	var _flexibel2 = _interopRequireDefault(_flexibel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var currentPageData = _flexibel2.default.find(function (page) {
	  return page.order === 2;
	});
	
	var Modal2 = function Modal2(_ref) {
	  var onRequestClose = _ref.onRequestClose,
	      value = _ref.value,
	      otherProps = _objectWithoutProperties(_ref, ['onRequestClose', 'value']);
	
	  return _react2.default.createElement(
	    _reactModal2.default,
	    _extends({
	      className: 'Modal',
	      overlayClassName: 'ModalOverlay',
	      isOpen: true,
	      onRequestClose: onRequestClose
	    }, otherProps),
	    _react2.default.createElement(
	      'header',
	      { className: 'Modal__header' },
	      _react2.default.createElement(
	        'span',
	        { className: 'Modal__header__text' },
	        _react2.default.createElement(
	          'span',
	          { className: 'Modal__header__headline' },
	          currentPageData.modal.heading
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'Modal__header__title' },
	          value
	        )
	      ),
	      _react2.default.createElement('img', { alt: 'Gem', src: _gemFlexibel2.default, className: 'Modal__header__graphic' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'Modal__body' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'Modal__header__subtitle' },
	        currentPageData.modal.subheading
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        currentPageData.modal.body
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          onClick: onRequestClose,
	          to: '/A/',
	          type: 'button',
	          className: 'Modal__footer__button button button--primary button--large mt2'
	        },
	        currentPageData.modal.buttonText
	      )
	    )
	  );
	};
	
	var Quiz = function Quiz() {
	  return _react2.default.createElement(
	    _ModalContext.ModalConsumer,
	    null,
	    function (_ref2) {
	      var showModal = _ref2.showModal;
	      return _react2.default.createElement(
	        _Choices2.default,
	        { headline: currentPageData.quizHeading },
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer1.content
	            });
	          },
	          label: currentPageData.quizAnswer1.content,
	          note: currentPageData.quizAnswer1.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer2.content
	            });
	          },
	          label: currentPageData.quizAnswer2.content,
	          note: currentPageData.quizAnswer2.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer3.content
	            });
	          },
	          label: currentPageData.quizAnswer3.content,
	          note: currentPageData.quizAnswer3.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer4.content
	            });
	          },
	          label: currentPageData.quizAnswer4.content,
	          note: currentPageData.quizAnswer4.note
	        })
	      );
	    }
	  );
	};
	
	var Tutorial = function Tutorial() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'SectionHeader' },
	      _react2.default.createElement(
	        'span',
	        { className: 'SectionHeader__text' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SectionHeader__title' },
	          currentPageData.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SectionHeader__lead lead' },
	          currentPageData.subheading
	        )
	      ),
	      _react2.default.createElement('img', { alt: '', src: _floskelFlexibel2.default, className: 'SectionHeader__graphic' })
	    )
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(_Main2.default, { currentPageNum: 2, tutorial: _react2.default.createElement(Tutorial, null), quiz: _react2.default.createElement(Quiz, null), hasNav: false });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _flexibel = __webpack_require__(62);
	
	var _flexibel2 = _interopRequireDefault(_flexibel);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _BottomNav = __webpack_require__(28);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var currentPageNum = _ref.currentPageNum,
	      tutorial = _ref.tutorial,
	      quiz = _ref.quiz,
	      hasNav = _ref.hasNav;
	
	  // Get page data from data/pageData.js
	  var currentPageData = _flexibel2.default.find(function (page) {
	    return page.order === currentPageNum;
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'Shell' },
	    _react2.default.createElement(
	      _Content2.default,
	      { header: true },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'Jakten | ' + currentPageData.title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main__content' },
	          tutorial
	        ),
	        quiz ? _react2.default.createElement(
	          'div',
	          { className: 'quiz-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'quiz__content' },
	            quiz
	          )
	        ) : null,
	        hasNav ? _react2.default.createElement(_BottomNav2.default, {
	          navTitle: currentPageData.navTitle,
	          currentPageNum: currentPageNum,
	          pageData: _flexibel2.default
	        }) : null
	      )
	    )
	  );
	};
	
	Main.propTypes = {
	  tutorial: _propTypes2.default.node.isRequired,
	  quiz: _propTypes2.default.node,
	  hasNav: _propTypes2.default.bool,
	  currentPageNum: _propTypes2.default.number.isRequired
	};
	
	Main.defaultProps = {
	  hasNav: true,
	  quiz: ''
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-flexibel-02-js-4918b660e1ad8d8992a0.js